// Parse anything into a float

"use strict";

module.exports = function coerceFloat(x) {

	var strx = (x || '').toString();
	strx = strx.replace(/[^-\.0-9]/g, '');
	if (! strx) return 0;

	var y = parseFloat(strx);
	if (y) return y;
	return 0;
}